/**
 * 书架合集/书单成员关系维护
 */

export function removeBooksFromAllCollections(state, bookIds, saveCollections) {
  const ids = Array.isArray(bookIds) ? bookIds.map(String) : [];
  if (ids.length === 0) return false;

  let changed = false;
  const membership = state.collectionMembership || {};
  Object.keys(membership).forEach(collectionId => {
    const list = membership[collectionId];
    if (!Array.isArray(list) || list.length === 0) return;
    const next = list.filter(id => !ids.includes(String(id)));
    if (next.length !== list.length) {
      membership[collectionId] = next;
      changed = true;
    }
  });

  if (changed && typeof saveCollections === 'function') saveCollections();
  return changed;
}

export function removeBooksFromAllBooklists(state, bookIds, saveBooklists) {
  const ids = Array.isArray(bookIds) ? bookIds.map(String) : [];
  if (ids.length === 0) return false;

  let changed = false;
  const membership = state.booklistMembership || {};
  Object.keys(membership).forEach(booklistId => {
    const list = membership[booklistId];
    if (!Array.isArray(list) || list.length === 0) return;
    const next = list.filter(id => !ids.includes(String(id)));
    if (next.length !== list.length) {
      membership[booklistId] = next;
      changed = true;
    }
  });

  if (changed && typeof saveBooklists === 'function') saveBooklists();
  return changed;
}

export function addBooksToCollection(state, collectionId, bookIds, saveCollections) {
  if (!collectionId) return;
  const ids = Array.isArray(bookIds) ? bookIds.map(String) : [];
  if (ids.length === 0) return;

  const membership = state.collectionMembership || {};
  const current = Array.isArray(membership[collectionId]) ? membership[collectionId].map(String) : [];
  const next = Array.from(new Set([...current, ...ids]));
  membership[collectionId] = next;
  state.collectionMembership = membership;

  if (typeof saveCollections === 'function') saveCollections();
}
